export default function() {
  return {
    federalStates: [],
  };
}
